import { render } from "./FreelancerCard.vue?vue&type=template&id=16d93555&scoped=true"
import script from "./FreelancerCard.vue?vue&type=script&lang=js"
export * from "./FreelancerCard.vue?vue&type=script&lang=js"

import "./FreelancerCard.vue?vue&type=style&index=0&id=16d93555&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d93555"]])

export default __exports__